'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  0% {\n    background-position: 0% 25%\n  }\n  50% {\n    background-position: 100% 65%\n  }\n  100% {\n    background-position: 0% 25%\n  }\n'], ['\n  0% {\n    background-position: 0% 25%\n  }\n  50% {\n    background-position: 100% 65%\n  }\n  100% {\n    background-position: 0% 25%\n  }\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  background: linear-gradient(90deg,\n    ', ',\n    ', ');\n  background-size: 200% 400%;\n  animation: 1.5s ', ' infinite;\n  width: ', ';\n  height: ', ';\n  margin: ', ';\n  padding: ', ';\n  border-radius: 4px;\n'], ['\n  background: linear-gradient(90deg,\n    ', ',\n    ', ');\n  background-size: 200% 400%;\n  animation: 1.5s ', ' infinite;\n  width: ', ';\n  height: ', ';\n  margin: ', ';\n  padding: ', ';\n  border-radius: 4px;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var animateGradient = (0, _styledComponents.keyframes)(_templateObject);

var Placeholder = _styledComponents2.default.div(_templateObject2, function (props) {
  return props.colorStop1 || '#e7e7e7';
}, function (props) {
  return props.colorStop2 || 'white';
}, animateGradient, function (props) {
  return props.width || '200px';
}, function (props) {
  return props.height || '30px';
}, function (props) {
  return props.margin || '20px';
}, function (props) {
  return props.padding;
});

exports.default = Placeholder;
//# sourceMappingURL=Placeholder.js.map


//////////////////
// WEBPACK FOOTER
// ../placeholder/lib/Placeholder.js
// module id = 741
// module chunks = 0